module.exports = __webpack_public_path__ + "media/back-to-the-star.64268592.mp4";